

















































import {Component, Vue} from "vue-property-decorator";
import formatDate from '@/filters/DateFormatter';
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import CollectionSlotSelection from '@/components/collection-slot/CollectionSlotSelection.vue'
import CollectionSlotOrdersList from '@/components/collection-slot/CollectionSlotOrdersList.vue'
import {Inject} from "vue-typedi";
import {Slot} from "@/model/collection/Slot";
import {Support} from "@/model/support/Support";
import {Drive} from "@/model/Drive";
import {PlaybackService, Sounds} from "@/services/PlaybackService";
import {SupportService} from "@/services/SupportService";

@Component({
  components: {ConfirmDialog, CollectionSlotSelection, CollectionSlotOrdersList},
  filters: {formatDate}
})
export default class CollectionSlotBody extends Vue {

  @Inject()
  private supportService!: SupportService;
  @Inject()
  private playbackService!: PlaybackService;

  selectedDrive: Drive = null;
  selectedSlot: Slot = null;
  supportsToCollect: Support[] = [];
  allCreatedSupports: Support[] = [];
  collectionErrorOptions: CollectionErrorOptions = null;
  lastSupportInError: string = null;
  supportErrorCounter: number = 1;


  POPIN_BODY_TEXT_SUPPORT_NOT_FOUND: string = "Le support scanné n'est pas reconnu";
  POPIN_BODY_TEXT_SUPPORT_ALREADY_COLLECTED: string = "Le support scanné est déjà collecté";
  POPIN_BODY_TEXT_COLLECT_FAILED: string = "Veuillez scanner de nouveau le support";
  POPIN_BODY_TEXT_TECHNICAL_ERROR: string = "Collecte impossible, merci de contacter le support technique";

  onSlotSelected(event: { drive: Drive, slot: Slot, supportsToCollect: Support[], allCreatedSupports: Support[] }): void {
    this.selectedDrive = event.drive;
    this.selectedSlot = event.slot;
    this.supportsToCollect = event.supportsToCollect;
    this.allCreatedSupports = event.allCreatedSupports;
  }

  collectSupportFromOtherSlot() {
    this.supportService.collectSupport(this.collectionErrorOptions.supportCode, this.selectedSlot.dueDate)
      .then((support: Support) => {
        this.supportsToCollect.push(support);
        this.playbackService.play(Sounds.SCAN);
        this.acknowledgeScanError();
      }).catch(() => {
      const updatedOptions = {
        ...this.collectionErrorOptions,
        context: CollectionErrorContexts.COLLECTION_FAILED
      };
      this.playbackService.play(Sounds.ERROR);
      this.onScanError(updatedOptions);
    });
  }

  unselectSlot() {
    this.supportsToCollect = [];
    this.selectedSlot = null;
  }

  onScanError(options: CollectionErrorOptions): void {

    if (options.supportCode === this.lastSupportInError) {
      this.supportErrorCounter++;
    } else {
      this.lastSupportInError = options.supportCode;
      this.supportErrorCounter = 1;
    }

    const updatedOptions = { ...options };

    if (this.supportErrorCounter > 2) {
      updatedOptions.context = CollectionErrorContexts.TECHNICAL_ERROR;
    }

    this.collectionErrorOptions = updatedOptions;
  }

  acknowledgeScanError(): void {
    this.collectionErrorOptions = null;
    (this.$refs.collectionSlotOrdersList as any)?.focusInput();
  }

  get isSupportScanInvalid(): boolean {
    return this.isSupportNotFound || this.isSupportAlreadyCollected || this.hasCollectionTechnicalError;
  }

  get isSupportNotFound(): boolean {
    return this.errorContext === CollectionErrorContexts.SUPPORT_NOT_FOUND;
  }

  get isSupportAlreadyCollected(): boolean {
    return this.errorContext === CollectionErrorContexts.SUPPORT_ALREADY_COLLECTED;
  }

  get hasSupportCollectionFailed(): boolean {
    return this.errorContext === CollectionErrorContexts.COLLECTION_FAILED;
  }

  get isSupportFromOtherSlot(): boolean {
    return this.errorContext === CollectionErrorContexts.SUPPORT_FROM_OTHER_SLOT;
  }

  get hasCollectionTechnicalError(): boolean {
    return this.errorContext === CollectionErrorContexts.TECHNICAL_ERROR;
  }

  get canHandleSupports(): boolean {
    return this.selectedDrive?.wms === "MAWM";
  }

  get errorContext(): CollectionErrorContexts | null {
    return this.collectionErrorOptions?.context ?? null;
  }

  get supportCode(): string {
    return this.collectionErrorOptions?.supportCode ?? '';
  }

}

export enum CollectionErrorContexts {
  SUPPORT_NOT_FOUND = 'SUPPORT_NOT_FOUND',
  SUPPORT_FROM_OTHER_SLOT = 'SUPPORT_FROM_OTHER_SLOT',
  COLLECTION_FAILED = 'COLLECTION_FAILED',
  SUPPORT_ALREADY_COLLECTED = 'SUPPORT_ALREADY_COLLECTED',
  TECHNICAL_ERROR = 'TECHNICAL_ERROR'
}

export type CollectionErrorContext  =
  CollectionErrorContexts.SUPPORT_NOT_FOUND
  | CollectionErrorContexts.SUPPORT_FROM_OTHER_SLOT
  | CollectionErrorContexts.COLLECTION_FAILED
  | CollectionErrorContexts.SUPPORT_ALREADY_COLLECTED
  | CollectionErrorContexts.TECHNICAL_ERROR;

export class  CollectionErrorOptions {
  context: CollectionErrorContext;
  supportCode: string;
}
